import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../macroscopia.action';
import WebapiCommon from '@common/util/webapi.common';
import HistoricoLaudoPage from './historico-laudo.page';

class HistoricoLaudoContainer extends Component {
  constructor() {
    super();
    this.textAreaRef = React.createRef();
    this.state = {
      laudoHistoricoLista: [],
      textoLaudoHistorico: undefined,
      textAreaAltura: '0px',
    };
  }

  render() {
    return (
      <HistoricoLaudoPage
        altura={this.props.altura}
        alturaEditor={this.getAltura.bind(this)}
        laudoHistoricoLista={this.state.laudoHistoricoLista}
        textoLaudoHistorico={this.state.textoLaudoHistorico}
        obterDetalhesLaudoHistorico={this.obterDetalhesLaudoHistorico.bind(
          this
        )}
        fecharDetalhesTextoLaudoHistorico={this.fecharDetalhesTextoLaudoHistorico.bind(
          this
        )}
        textAreaAltura={this.state.textAreaAltura}
        textAreaRef={this.textAreaRef}
      />
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.textoLaudoHistorico !== this.state.textoLaudoHistorico &&
      this.textAreaRef.current !== null
    ) {
      this.setState({
        textAreaAltura: this.textAreaRef.current.scrollHeight + 'px',
      });
    }
  }

  componentDidMount() {
    this.props.actions.showFadeCarregando(true);
    WebapiCommon.getListaLaudoHistorico(this.props.detalhes.laudo).then(
      (laudos) => {
        this.setState({
          laudoHistoricoLista: laudos,
        });
        this.props.actions.showFadeCarregando(false);
      }
    );
  }

  componentWillUnmount() {
    this.setState({
      laudoHistoricoLista: [],
      textoLaudoHistorico: undefined,
      textAreaAltura: '0px',
    });
  }

  getAltura = () => {
    return (
      document.getElementById('container-editor') &&
      document.getElementById('container-editor').style.height
    );
  };

  fecharDetalhesTextoLaudoHistorico() {
    this.setState({
      textoLaudoHistorico: undefined,
      textAreaAltura: '0px',
    });
  }

  obterDetalhesLaudoHistorico(laudoHistorico) {
    this.props.actions.showFadeCarregando(true);
    WebapiCommon.getTextoLaudoHistorico(
      this.props.detalhes.laudo,
      laudoHistorico.laudoHistoricoId
    ).then((laudos) => {
      this.setState({
        textoLaudoHistorico: {
          texto: laudos.textoEtapa,
          usuario: laudoHistorico.usuario,
          dataAlteracao: laudoHistorico.dataAlteracao,
        },
      });
      this.props.actions.showFadeCarregando(false);
    });
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
};

const mapStateToProps = (state) => {
  return {
    detalhes: state.commonReducer.detalhes,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HistoricoLaudoContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/tabs/historicolaudo/historico-laudo.container.js